export const SdfCardEnglishLabels = {
  common: {
    continue: 'Continue',
    done: 'Done',
    yourPayAmount: 'Your payment amount',
    yourWithdrawAmount: 'Your withdraw amount',
    total: 'Total',
    myInfo: 'My information',
    legalName: 'Legal name',
    dateOfBirth: 'Date of birth',
    address: 'Address',
    phoneNumber: 'Phone number',
    myId: 'My ID',
    idType: 'ID type',
    idNumber: 'ID number',
    countryOfIssue: 'Country of issue',
    stateLabel: 'State or province of issue',
    paymentLocation: 'Payment Location',
    selectLocation: 'Select Location',
    changeLocation: 'Change location',
    fees: 'Fees',
    taxes: 'Taxes',
    totalCost: 'Total cost',
    totalAmount: 'Total amount',
    notifcation: {
      one: 'Be sure your information match your ID',
    },
  },
  landingPage: {
    cashInHeadr: 'Start cash-in with MoneyGram',
    cashOutHeadr: 'Start cash-out with MoneyGram',
    cashInCountry: 'Cash-in country',
    cashOutCountry: 'Cash-out country',
    stateOrProvince: 'State or province',
    countrySelected: 'Country selected',
    searchForCountryPlaceholder: 'Search for country',
    searchForStateOrProvincePlaceholder: 'Search for state or province',
    allCountries: 'All countries',
    allStatesOrProvinces: 'All states or provinces',
    stateOrProvinceSelected: 'State or province selected',
    selectCurrency: 'Select currency',
    lookupLocation: 'Lookup location',
    multiCurrency: 'has multiple currencies you can send',
    disclaimer: {
      one: '1 The exchange currency amount will be converted to your local currency by the agent at the time of payment',
    },
    payment: {
      payMethod: 'Payment method',
      receiveMethod: 'Receive method',
      cashPickUp: 'Cash pickup',
      location: 'Location',
      cashLocation: 'Cash at location',
      cashInlocationFeesInfo:
        'Fees vary by location. Once you select a location, fees will appear for your estimation.',
      cashOutlocationFeesInfo:
        'Please note that you can go to any location from your search results for your cash pickup. Fees vary by location.',
    },
  },
  locationMaps: {
    searchCityZipCode: 'Search By City Zip Code',
    searchArea: 'Search this area',
    viewDetails: 'View Details',
    locationServices: 'Services',
    changeLocation: 'Change Location',
    notification: {
      infoVariable:
        'Specific hours of operation may vary. Please contact the location for more information.',
      searchNoResult:
        'We’re sorry, but we can’t locate any location with your search. Please try it again.',
      locationUnavailable:
        'No MoneyGram location is currently available for USDC services near you.',
      tryAgainFuture: 'Please try again in the near future.',
    },
  },
  moreInfoPage: {
    littleInfo: 'We need a little bit more information about you',
    photoId:
      'This will assist our store agent in verifying your identity when you present your photo ID',
    storeInfo:
      'We kindly ask the following detail to ensure a seamless experience at your store selected',
  },
  basicInfoPage: {
    header: 'Basic Information',
  },
  addressPage: {
    header: 'Address',
  },
  reviewPage: {
    reviewHeader: 'Review information',
    paymentLocation: 'Payment location',
    paymentInformation: 'Payment information',
    withdraw: {
      yourWithdrawalAmount: 'Your withdrawal amount',
    },
    deposit: {
      yourConvertingMethod: 'Your converting method',
    },
  },
  confirmationPage: {
    cashInStatusHeader: 'All set! Head to your payment location',
    cashOutStatusHeader: 'All set! Head to your pickup location',
    payAtStore: 'Pay at store',
    pickAmount: 'Your pickup amount',
    amountAdding: 'You are adding to %s USDC your wallet',
    amountWithdraw: 'You are withdrawing %s USDC from your wallet',
    receiver: 'Receiver',
    howToPay: 'How to pay your cash at location',
    accountNumber: 'Account number',
    walletBalance:
      'Your wallet balance will be updated within a few minutes after payment',
    nextStepsHeading: 'Next steps are easy',
    nextSteps: {
      idType: {
        ALN: 'Alien ID',
        DRV: 'Drivers License',
        GOV: 'Government ID',
        PAS: 'Passport',
        STA: 'State ID',
      },
      paraOne: 'Within 24 hours, head to your payment location',
      paraTwo: 'Have your %s selected and Account # above ready',
      tellTheStoreEmployee: 'Tell the store employee',
      fundsIn: {
        common: {
          yourNameAsReceiver: 'Your name as receiver',
          serviceOption:
            "The service option for employee to select is 'USDC wallet'",
        },
        paraThree: {
          implicitTransUSCAN: {
            purpose: 'I am here to send money to Texas, United States',
          },
          implicitNoneUSCAN: {
            purpose: 'I am here to send money to The United States',
          },
          explicit: {
            paraTwo: 'Have your %s selected',
            purpose:
              'Tell the store employee, "I am here to complete my MoneyGram transaction."',
          },
        },
      },
      fundsOut: {
        paraOne: 'Within 60 days, head to any store from your search result',
        receiveCash: 'I am here to receive cash from a MoneyGram transaction',
      },
    },
  },
};

export const SdfCardFrechLabels = {
  common: {
    continue: 'Fr-Continue',
    done: 'Fr-Done',
    yourPayAmount: 'Fr-Your payment amount',
    yourWithdrawAmount: 'Fr-Your withdraw amount',
    total: 'Fr-Total',
    myInfo: 'Fr-My information',
    legalName: 'Fr-Legal name',
    dateOfBirth: 'Fr-Date of birth',
    address: 'Fr-Address',
    phoneNumber: 'Fr-Phone number',
    myId: 'Fr-My ID',
    idType: 'Fr-ID type',
    idNumber: 'Fr-ID number',
    idDetails: 'ID details',
    countryOfIssue: 'Fr-Country of issue',
    stateLabel: 'Fr-State or province of issue',
    paymentLocation: 'Fr-Payment Location',
    selectLocation: 'Fr-Select Location',
    changeLocation: 'Fr-Change location',
    fees: 'Fr-Fees',
    taxes: 'Fr-Taxes',
    totalCost: 'Fr-Total cost',
    totalAmount: 'Fr-Total amount',
    notifcation: {
      one: 'Fr-Be sure your information match your ID',
    },
  },
  landingPage: {
    cashInHeadr: 'Fr-Start cash-in with MoneyGram',
    cashOutHeadr: 'Fr-Start cash-out with MoneyGram',
    cashInCountry: 'Fr-Cash-in country',
    cashOutCountry: 'Fr-Cash-out country',
    stateOrProvince: 'Fr-State or province',
    countrySelected: 'Fr-Country selected',
    searchForCountryPlaceholder: 'Fr-Search for country',
    searchForStateOrProvincePlaceholder: 'Fr-Search for state or province',
    allCountries: 'Fr-All countries',
    allStatesOrProvinces: 'Fr-All states or provinces',
    stateOrProvinceSelected: 'Fr-State or province selected',
    selectCurrency: 'Fr-Select currency',
    lookupLocation: 'Fr-Lookup location',
    multiCurrency: 'Fr-has multiple currencies you can send',
    disclaimer: {
      one: 'Fr-1 The exchange currency amount will be converted to your local currency by the agent at the time of payment',
    },
    payment: {
      payMethod: 'Fr-Payment method',
      receiveMethod: 'Fr-Receive method',
      cashPickUp: 'Fr-Cash pickup',
      location: 'Fr-Location',
      cashLocation: 'Fr-Cash at location',
      cashInlocationFeesInfo:
        'Fr-Fees vary by location. Once you select a location, fees will appear for your estimation.',
      cashOutlocationFeesInfo:
        'Fr-Please note that you can go to any location from your search results for your cash pickup. Fees vary by location.',
    },
  },
  locationMaps: {
    searchCityZipCode: 'Fr-Search By City Zip Code',
    searchArea: 'Fr-Search this area',
    viewDetails: 'Fr-View Details',
    locationServices: 'Fr-Services',
    changeLocation: 'Fr-Change Location',
    notification: {
      infoVariable:
        'Fr-Specific hours of operation may vary. Please contact the location for more information.',
      searchNoResult:
        'Fr-We’re sorry, but we can’t locate any location with your search. Please try it again.',
      locationUnavailable:
        'Fr-No MoneyGram location is currently available for USDC services near you.',
      tryAgainFuture: 'Fr-Please try again in the near future.',
    },
  },
  moreInfoPage: {
    littleInfo: 'Fr-We need a little bit more information about you',
    photoId:
      'Fr-This will assist our store agent in verifying your identity when you present your photo ID',
    storeInfo:
      'Fr-We kindly ask the following detail to ensure a seamless experience at your store selected',
  },
  basicInfoPage: {
    header: 'Fr-Basic Information',
  },
  addressPage: {
    header: 'Fr-Address',
  },
  reviewPage: {
    reviewHeader: 'Fr-Review information',
    paymentLocation: 'Fr-Payment location',
    paymentInformation: 'Fr-Payment information',
    withdraw: {
      yourWithdrawalAmount: 'Fr-Your withdrawal amount',
    },
    deposit: {
      yourConvertingMethod: 'Fr-Your converting method',
    },
  },
  confirmationPage: {
    cashInStatusHeader: 'Fr-All set! Head to your payment location',
    cashOutStatusHeader: 'Fr-All set! Head to your pickup location',
    payAtStore: 'Fr-Pay at store',
    pickAmount: 'Fr-Your pickup amount',
    amountAdding: 'Fr-You are adding to %s USDC your wallet',
    amountWithdraw: 'Fr-You are withdrawing %s USDC from your wallet',
    receiver: 'Fr-Receiver',
    howToPay: 'Fr-How to pay your cash at location',
    accountNumber: 'Fr-Account number',
    walletBalance:
      'Fr-Your wallet balance will be updated within a few minutes after payment',
    nextStepsHeading: 'Fr-Next steps are easy',
    nextSteps: {
      idType: {
        ALN: 'Fr-Alien ID',
        DRV: 'Fr-Drivers License',
        GOV: 'Fr-Government ID',
        PAS: 'Fr-Passport',
        STA: 'Fr-State ID',
      },
      paraOne: 'Fr-Within 24 hours, head to your payment location',
      paraTwo: 'Fr-Have your %s selected and Account # above ready',
      tellTheStoreEmployee: 'Fr-Tell the store employee',
      fundsIn: {
        common: {
          yourNameAsReceiver: 'Fr-Your name as receiver',
          serviceOption:
            "Fr-The service option for employee to select is 'USDC wallet'",
        },
        paraThree: {
          implicitTransUSCAN: {
            purpose: 'Fr-I am here to send money to Texas, United States',
          },
          implicitNoneUSCAN: {
            purpose: 'Fr-I am here to send money to The United States',
          },
          explicit: {
            paraTwo: 'Fr-Have your %s selected',
            purpose:
              'Fr-Tell the store employee, "I am here to complete my MoneyGram transaction."',
          },
        },
      },
      fundsOut: {
        paraOne: 'Fr-Within 60 days, head to any store from your search result',
        receiveCash:
          'Fr-I am here to receive cash from a MoneyGram transaction',
      },
    },
  },
};

const sdfLabelsJSON = {
    "stellar": {
        "noToken": "Something is wrong. Go back to your wallet and try again",
        "next": "Next",
        "confirm": "Confirm",
        "cancelText": "Cancel",
        "ok": "Ok",
        "close": "Close",
        "submit": "Submit",
        "dismiss": "Dismiss",
        "withdraw": "Withdraw",
        "deposit": "Deposit",
        "openInNew": "open_in_new",
        "excludesWalmart": "Excludes Walmart",
        "optionNotFound": "Option not found!",
        "saveAsImage": "Save as Image",
        "stateNotFound": "State not found",
        "countryNotFound": "Country not found",
        "countryNotSupported": "Country is not supported",
        "enterValidDate": "Please enter valid future date",
        "postalCodeRequired": "Postal code is required",
        "cellphoneRequired": "Cellphone number is required",
        "telephoneRequired": "Telephone number is required",
        "estimate": {
            "header": {
                "withdraw": "Withdraw your USDC at a participating MoneyGram location.",
                "deposit": "Purchase USDC with cash at a participating MoneyGram location."
            },
            "subheader": "Let’s start your purchase now!",
            "cashOutCountry": "Cash-Out Country",
            "cashInCountry": "Cash-In Country",
            "cashOutState": "Cash-Out State/Province",
            "cashInState": "Cash-In State",
            "amount": "Amount",
            "currecyFootNote": "Subject to currency availability.",
            "noCashOutAllowed": "Sorry this service is not available in",
            "returnToWallet": "Return to Wallet",
            "exchangeCurrency": "Exchange Currency",
            "indicativeCountryHelpText": "The USD amount will be converted to your local currency by the agent at the time of payment.",
            "note": "Note:",
            "searchACountry": "Search a country..."
        },
        "languageSelector": {
            "ENGLISH": "English",
            "PORTUGUESE": "Português",
            "FRENCH": "Français",
            "SPANISH": "Español",
            "UKRAINIAN": "Українська",
            "GERMAN": "Deutsch",
            "GREEK": "Ελληνικά",
            "ARABIC": "Arabic",
            "LITHUANIAN": "Lietuvių",
            "RUSSIAN": "Русский",
            "NORWEGIAN": "Norsk",
            "ITALIAN": "Italiano",
            "ROMANIAN": "Română",
            "SPANISH_SPAIN": "Español (España)",
            "SPANISH_EUROPEAN": "Español (Europa)",
            "POLISH": "polski",
            "DANISH": "Dansk"
        },
        "location": {
            "findCashoutLocation": "Find a Convenient Cash-Out Location Near You",
            "findPaymentLocation": "Find a Payment Location",
            "selectPaymentLocation": "Select a Payment Location",
            "searchHelpText": "Search Address, City, State or Postal Code",
            "selectLocation": "Select Location",
            "openUntil": "Open Until",
            "addToPhone": "Add Minutes to Phone",
            "bankAccountRequired": "Branch bank account is required",
            "billPayment": "Pay a Bill",
            "distanceMItoKM": "Distance converted from Mi (Miles) to Km (Kilometers) per locale",
            "friHours": "Friday",
            "hours": "Hours",
            "hoursWarning": "Specific Hours Of Operation May Vary. Please Contact The Location For More Information",
            "monHours": "Monday",
            "moneyOrder": "Money Order",
            "purchaseMoneyorder": "Purchase Money Order",
            "purchaseMoneygramCard": "Purchase a MoneyGram Prepaid Card",
            "recCurrencies": "Receive Currency",
            "receiveMoney": "Receive Money",
            "receiveToCard": "Receive Money to a Prepaid Card",
            "reloadMoneygramCard": "Reload a MoneyGram Prepaid Card",
            "satHours": "Saturday",
            "sendCurrencies": "Send Currency",
            "sendMoney": "Send Money",
            "services": "Services",
            "sunHours": "Sunday",
            "thuHours": "Thursday",
            "tueHours": "Tuesday",
            "wedHours": "Wednesday",
            "xpressPackage": "Purchase MoneyGram xpress® Money Transfer Packages",
            "agentURLTextFinland": "Start your transaction online at R-Kisoki",
            "agentURLTextUK": "Start your transaction online at Tesco",
            "backBtnTxt": "Back",
            "changeLocation": "Change Location",
            "depositLocation": "Payment Location",
            "closedOpenTxt": "Closed - Open",
            "closedTxt": "Closed",
            "closingSoonTxt": "Closing Soon",
            "currentlyOpenTxt": "Currently open",
            "filterServiceTxt": "Filter by Service",
            "findLocationTxt": "Select a Payment Location",
            "findLocation": "Find a Location",
            "hoursOperationTxt": "Specific hours of operation may vary. Please contact the location for more information",
            "locationsMatchedTxt": "Locations Match Your Search",
            "name": {
                "description": "FIND the MoneyGram® agent location closest to you … over 350,000 Money Transfer locations worldwide.",
                "robots": "translate, index, follow, all",
                "keywords": "Moneygram Locations in The United States, MoneyGra…, Closest Moneygram location in The United States"
            },
            "noFollow": "null",
            "property": {
                "title": "MoneyGram® Locations in The United States - MoneyGram.com",
                "description": "FIND the closest MoneyGram® agent location near yo…00 MoneyGram® Money Transfer locations worldwide."
            },
            "relCanonicalLink": "locations",
            "title": "MoneyGram® in The United States : Find a MoneyGram Agent Location Near You in The United States",
            "noLocationAvailable": "Sorry, there are no MoneyGram locations in this area",
            "openUntilTxt": "Open Until",
            "searchInputTxt": "Search Address, City, State or Zip",
            "selectLocationBtnTxt": "Select Location",
            "selectPayLocationTxt": "Select a Payment Location",
            "selectPickupLocationTxt": "Select a Pick Up Location",
            "sendLocation": "Send Location",
            "typeNewAddress": "Sorry, something has gone wrong. Please type in an address above.",
            "unableToLocation": "Sorry, we are unable to locate you. Please type in an address above.",
            "viewMoreServicesTxt": "More…",
            "miles": "Miles",
            "kilometers": "Kilometers",
            "locationsUrl": "https://www.moneygram.com/intl/en/en-locator"
        },
        "estimateConfirmation": {
            "purchaseAmount": "Purchase Amount",
            "cashOutAmount": "Cash-Out Amount",
            "fees": "Fees",
            "taxes": "Taxes",
            "discount": "Discount",
            "exchangeRate": "Exchange Rate",
            "transactionDetails": "Transaction Details",
            "depositAmount": "Deposit Amount",
            "withdrawalAmount": "Withdrawal Amount",
            "amountToPay": "Amount to Pay",
            "exchangeAmount": "Exchange Amount"
        },
        "registration": {
            "header": "Now, we just need a little more information about you.",
            "subheader": "Please make sure the name and date of birth match the ID you present in store.",
            "personalInfoHeader": "Personal Information",
            "firstName": "Legal First Name",
            "middleName": "Middle Name (If Listed On ID)",
            "lastName": "Legal Last Name",
            "secondLastName": "Second Last Name (If Listed On ID)",
            "dateOfBirth": "Date Of Birth",
            "dateOfBirthComponent": {
                "months": {
                    "JAN": "Jan",
                    "FEB": "Feb",
                    "MAR": "Mar",
                    "APR": "Apr",
                    "MAY": "May",
                    "JUN": "Jun",
                    "JUL": "Jul",
                    "AUG": "Aug",
                    "SEP": "Sep",
                    "OCT": "Oct",
                    "NOV": "Nov",
                    "DEC": "Dec"
                },
                "DAY": "Day",
                "MONTH": "Month",
                "YEAR": "Year",
                "enterValidDOB": "Please enter a valid Date of Birth"
            },
            "currentAddressInfoHeader": "Current Address and Phone Number",
            "address": "Address Line 1",
            "addressLine2": "Address Line 2",
            "city": "City",
            "country": "Country",
            "state": "State/Province",
            "postalCode": "Postal Code",
            "countryCode": "Country Code",
            "mobileNumber": "Mobile Number",
            "mobileCountry": "Mobile Couuntry",
            "errorMsgs": {
                "required": "is required",
                "pattern": "has invalid characters",
                "maxLength": "too long",
                "minLength": "too short",
                "invalid": "is invalid",
                "max": "You must be at least 18 years old",
                "min": "Date must be less than 100 years",
                "invalidPostalCode": "Please enter a valid postal code",
                "onlyAlphanumeric": "Please enter Alphanumeric text"
            },
            "review": "REVIEW",
            "confirmed": "CONFIRMED",
            "confirmationCheckBoxStrings": {
                "stringOne": "Yes, my information above is correct",
                "stringTwo": "Please make sure the name and date of birth match the ID you present in store."
            }
        },
        "gffp": {
            "header": "Please provide the following additional information.",
            "reminderText": "Be sure to bring the Photo ID you used for this transaction with you to the store.",
            "validations": {
                "longerChar": "cannot be longer than",
                "mustLongChar": "must be longer than",
                "characters": "characters",
                "required": "is required",
                "invalid": "is invalid"
            },
            "gffpLabels": {
                "senderFirstName": "First Name",
                "senderMiddleName": "Middle Name (If Applicable)",
                "senderLastName": "Last Name",
                "senderSecondLastName": "Second Last Name (If Applicable)",
                "senderTitle": "Personal Details",
                "additionalTransactionDetailsTitle": "Personal Details",
                "senderDateOfBirth": "Date of Birth",
                "senderBirthCountryCode": "Country of Birth",
                "senderOccupationCode": "Occupation",
                "senderAdditionalTransactionDetailsPurposeOfTransactionCode": "Purpose of Transaction",
                "senderAdditionalTransactionDetailsSourceOfFundsCode": "Source of Funds",
                "senderAdditionalTransactionDetailsProofOfFundsCode": "Proof of Funds",
                "senderAdditionalTransactionDetailsIntendedUseOfMGIServicesCode": "Intended Use of MGI Services",
                "senderAdditionalTransactionDetailsRelationshipToReceiver": "Relationship to Receiver",
                "senderPrimaryIdentificationTitle": "Identification Details",
                "senderSecondaryIdentificationTitle": "Additional Details",
                "senderAdditionalTransactionDetails": "Additional Details",
                "senderPrimaryIdentificationId": "Id Number",
                "senderPrimaryIdentificationIssueCountryCode": "Country of Issue",
                "senderPrimaryIdentificationIssueCountrySubdivisionCode": "State/Province of Issue",
                "senderPrimaryIdentificationTypeCode": "Id Type",
                "senderSecondaryIdentificationId": "Id Number",
                "senderSecondaryIdentificationIssueCountryCode": "Country of Issue",
                "senderSecondaryIdentificationIssueCountrySubdivisionCode": "State/Province of Issue",
                "senderSecondaryIdentificationTypeCode": "Id Type 1",
                "senderPrimaryIdentificationExpirationDate": "Identification Expiration Date",
                "senderCitizenshipCountryCode": "Country of Citizenship",
                "additionalTransactionDetails": "Additional Details",
                "additionalTransactionDetailsIntendedUseOfMGIServicesCode": "Intended Use of MGI Services",
                "additionalTransactionDetailsProofOfFundsCode": "Proof of Funds",
                "additionalTransactionDetailsPurposeOfTransactionCode": "Purpose of Transaction",
                "additionalTransactionDetailsRelationshipToReceiver": "Relationship to Receiver",
                "additionalTransactionDetailsSourceOfFundsCode": "Source of Funds",
                "expirationYear": "Expiry Year",
                "expirationMonth": "Expiry Month",
                "expirationDay": "Expiry Day",
                "issueAuthority": "Issuing Authority",
                "issueCity": "Issuing City",
                "issueYear": "Year of Issue",
                "issueMonth": "Month of Issue",
                "issueDay": "Day of Issue",
                "relationshipToReceiver": "Relationship to Receiver",
                "senderGenderCode": "Gender",
                "senderMotherTitle": "Additional Details",
                "senderMotherMaidenName": "Mother's Maiden Name",
                "senderAdditionalFamilyNamesMothersMaidenName": "Mother's Maiden Name",
                "senderAdditionalFamilyNamesTitle": "Additional Details",
                "senderNotificationLanguagePreference": "Notification Language Preference",
                "senderNotificationPreferenceDetailsType": "Notification preference details type",
                "senderAddressCountrySubdivisionCode": "Country of address",
                "errorMsgs": {
                    "expirationDateError": "Please enter valid date"
                },
                "mapiFieldErrorMessages": {
                    "typeCodeInputFieldMessage": "INVALID DATA",
                    "primaryIdInputFieldMessage": "Field contains too many characters.",
                    "issueCountryCodeInputFieldMessage": "Invalid country code",
                    "issueCountrySubdivisionCodeInputFieldMessage": "Invalid state for given country"
                }
            }
        },
        "summary": {
            "header": "Transaction Summary",
            "sender": "Sender",
            "receiver": "Receiver",
            "name": "Name",
            "sendCountry": "Send Country",
            "sendStateProvince": "Send State/Province",
            "receiveCountry": "Receive Country",
            "receiveStateProvince": "Receive State/Province",
            "transactionDetails": "Transaction Details",
            "paymentMethod": "Payment Method",
            "receiveMethod": "Receive Method",
            "wallet": "Wallet",
            "cash": "Cash",
            "cashPickup": "Cash Pickup",
            "costSummary": "Cost Summary",
            "fees": "Fees",
            "taxes": "Taxes",
            "discount": "Discount",
            "withdrawalFromWallet": "Withdrawal from Wallet",
            "totalCostAmountYouPay": "Total Cost (Amount you pay)",
            "totalCost": "Total Cost",
            "cashInAmount": "Cash-In Amount",
            "cashOutAmount": "Cash-Out Amount",
            "receiveAmount": "Receive Amount",
            "purchaseAmount": "Purchase Amount",
            "toPayAtLocation": "To Pay at Location",
            "depositToWallet": "Deposit to Wallet",
            "paymentLocation": "Payment Location",
            "submit": "Submit",
            "depositAmount": "Deposit Amount",
            "withdrawalAmount": "Withdrawal Amount",
            "amountToPay": "Amount to Pay",
            "country": "Country",
            "stateProvince": "State/Province",
            "personalInformation": "Personal Information",
            "paymentInformation": "Payment Information",
            "exchangeAmount": "Exchange Amount"
        },
        "confirmation": {
            "header": "Thank You!",
            "referenceNumber": "REFERENCE NUMBER",
            "transactionNumber": "TRANSACTION NUMBER",
            "nextSteps": "Next Steps",
            "helpText": "You can find the reference number in the transactions page of your wallet.",
            "sendLocation": "Send Location"
        },
        "statusUpdates": {
            "depositNonFromFreeLabels": {
                "firstPoint": "Head to your chosen MoneyGram location to pay for your purchase within 24 hours.",
                "secondPoint": "Tell the MoneyGram agent you are here to <strong>Send Money</strong>.",
                "firstBulletInSecondPoint": "When picking the service option, the agent should select the <strong>\"USDC Wallet\"</strong> option",
                "secondBulletInSecondPoint": "You are sending money to the <strong>United States</strong>. The amount is the same amount you designated.",
                "thirdBulletInSecondPoint": "<strong>If in US & Canada</strong>, The state of the transaction is <strong>Texas</strong>.",
                "thirdPoint": "Be sure to bring the <strong>Photo ID</strong> you used, and be prepared to follow additional instructions from the agent.",
                "firstBulletInThirdPoint": "If asked, provide your name as the <strong>Receiver</strong>",
                "secondBulletInThirdPoint": "When asked for the <strong>Account Number</strong> please provide the <strong>Single use transaction number</strong>",
                "fourthPoint": "Your wallet balance will be updated within a few minutes after payment."
            },
            "withdraw": {
                "firstBulletVibrant": "To <b>finalize</b> your transaction, please select ok below.",
                "firstBulletLobstr": "To <b>finalize</b> your transaction, please return to your wallet and withdraw the funds.",
                "secondBullet": "Head to a <b>MoneyGram location</b> near you and tell them you are <b>receiving cash</b>. Be sure to bring the <b>Reference Number</b> and the <b>Photo ID</b> you used for the transaction."
            },
            "deposit": {
                "firstBullet": "Head to your chosen <b>MoneyGram location</b> to pay for your purchase within <b>24 hours</b>.",
                "secondBullet": "Tell the MoneyGram agent you are here to <b>complete a transaction</b>. Be sure to bring the <b>Photo ID</b> you used.",
                "thirdBullet": "Your <b>wallet balance</b> will be updated within a few minutes after payment.",
                "secondBulletQRMobile": "If the agent asks for the QR code, please provide the QR code above. Be sure to bring the Photo ID you used.",
                "secondBulletQRDesktop": "If the agent asks for the QR code, please login to your wallet app on a mobile device to provide the QR code above. Be sure to bring the Photo ID you used."
            }
        },
        "transactionStatus": {
            "status": {
                "incomplete": "Incomplete",
                "incompleteHelpText": "The transaction was initiated but no funds have been exchanged. To start a new transaction, please return to your wallet.",
                "refundOnly": "Transaction can only be Refunded",
                "expired": "Transaction Expired",
                "expiredHelpText": "Transaction wasn’t completed before funds were exchanged. To start a new transaction, please return to your wallet.",
                "waitingForPayment": "Waiting for Payment",
                "waitingForPaymentSubmitted": "Waiting for Payment to be Submitted",
                "transactionProcessing": "Transaction Processing",
                "transactionReadyForPickup": "Transaction Ready for Pick-up",
                "readyForPayment": "Ready for Payment",
                "readyForPickup": "Ready for Pick-up",
                "transactionNumber": "TRANSACTION NUMBER",
                "readyForPickupHelpText": "Head to a MoneyGram location near you and tell them you are <b>receiving cash</b>. Be sure to bring the <b>Reference Number</b> and the <b>Photo ID</b> you used for the transaction.",
                "transactionPickedUp": "Transaction Picked-up",
                "transactionComplete": "Transaction Complete",
                "pendingRefund": "Refund Pending",
                "transactionRefunded": "Transaction Refunded",
                "refunded": "Refunded",
                "unknown": "Unknown",
                "transactionRejected": "Transaction Rejected",
                "onHoldContactMoneygram": "On Hold - Please Contact Moneygram",
                "unableToProcess": "Unable to Process"
            },
            "payForPurchase": "Pay for your purchase within 24 hours at your chosen location.",
            "payForPurchaseMoneygram": "Pay for your purchase within 24 hours at your chosen MoneyGram location.",
            "CancelTransfer": "Cancel Transfer",
            "referenceNumber": "REFERENCE NUMBER",
            "receiver": "Receiver",
            "sender": "Sender",
            "name": "Name",
            "legalName": "Legal Name",
            "receiveCountry": "Receive Country",
            "receiveStateProvince": "Receive State/Province",
            "sendCountry": "Send Country",
            "sendStateProvince": "Send State/Province",
            "cash": "Cash",
            "cashOut": "Cash-Out",
            "cashIn": "Cash-In",
            "cashOutAmount": "Cash-Out Amount",
            "cashOutCountry": "Cash-Out Country",
            "cashOutState": "Cash-Out State",
            "cashOutProvince": "Cash-Out Province",
            "paymentInformation": "Payment Information",
            "paymentLocation": "Payment Location",
            "kind": "Kind",
            "paymentMethod": "Payment Method",
            "receiveMethod": "Receive Method",
            "atLocation": "At Location",
            "walletId": "Wallet ID",
            "walletTransactionId": "Wallet Transaction ID",
            "transactionId": "Transaction ID",
            "costSummary": "Cost Summary",
            "withdrawalFromWallet": "Withdrawal from Wallet",
            "depositToWallet": "Deposit to Wallet",
            "fees": "Fees",
            "taxes": "Taxes",
            "discount": "Discount",
            "totalCostAmountYouPay": "Total Cost (Amount you pay)",
            "toPayAtLocation": "To Pay at Location",
            "reasonIsRequired": "Reason is required.",
            "agent": {
                "tipsForAgent": "Tips for your agent",
                "helpText": "Show the images below to your Moneygram agent if they have questions about how to complete this transfer.",
                "agentWorks": "AgentWorks",
                "deltaWorks": "Delta Works"
            },
            "contactMoneygramSupport": "<a href=\"https://www.callmoneygram.com/contactme\" target=\"_blank\">Contact MoneyGram Support</a> for further assistance",
            "receiveAmount": "Receive Amount",
            "refundSummary": "Refund Summary",
            "refundAmount": "Refund Amount",
            "depositAmount": "Deposit Amount",
            "withdrawalAmount": "Withdrawal Amount",
            "amountToPay": "Amount to Pay",
            "personalInformation": "Personal Information",
            "exchangeAmount": "Exchange Amount"
        },
        "termsAndConditions": {
            "and": "and",
            "disclaimerLabels": {
                "termsAndConditionsLabel": "Terms and Conditions",
                "privacyNotice": "Privacy Notice",
                "usdcUserAgreement": "USDC User Agreement",
                "applicableUsePolicy": "Applicable Use Policy",
                "privacyPolicy": "Privacy Policy"
            },
            "disclaimerLinks": {
                "circleTerms": "https://www.circle.com/en/legal/usdc-terms",
                "circleAccpPolicy": "https://www.circle.com/en/legal/acceptable-use-policy",
                "circlePolicy": "https://www.circle.com/en/legal/privacy-policy",
                "mgPrivacy": "https://www.moneygram.com/intl/Documents/V2-Documents/MPSI-US-Privacy-Notice-EN-Sept-2020.pdf",
                "mgTandC": "https://www.moneygram.com/mgo/%s1/%s2/m/crypto-terms-and-conditions"
            },
            "cashOut": {
                "webPara1": "Circle Internet Financial, Inc. (“Circle”) is responsible for providing the exchange service from USDC to USD. I agree to Circle’s <a href=\"https://www.circle.com/en/legal/usdc-terms\" target=\"_blank\">USDC User Agreement</a>, <a href=\"https://www.circle.com/en/legal/acceptable-use-policy\" target=\"_blank\">Applicable Use Policy</a> and <a href=\"https://www.circle.com/en/legal/privacy-policy\" target=\"_blank\">Privacy Policy</a>. I confirm I am the sole beneficial owner of the wallet and digital assets contained therein, and am acting solely on my own behalf.",
                "mobilePara1": {
                    "stringOne": "Circle Internet Financial, Inc. (“Circle”) is responsible for providing the exchange service from USDC to USD. I agree to Circle’s",
                    "stringTwo": ",",
                    "stringThree": ". I confirm I am the sole beneficial owner of the wallet and digital assets contained therein, and am acting solely on my own behalf."
                },
                "mgDisclaimerPara2": "MoneyGram Payment Systems, Inc. (“MoneyGram”) is responsible for providing the money transfer service from USD to USD (for USD Cash Out) and from USD to any other applicable currency (for non-USD Cash Out). MoneyGram may apply a currency exchange for any non-USD Cash Out. MoneyGram makes money from currency exchange. The amounts shown are only estimates based on variable exchange rates. Final fees have not been applied."
            },
            "cashIn": {
                "webPara1": "Circle Internet Financial, Inc. (“Circle”) is responsible for providing the exchange service from USD to USDC. I agree to Circle’s  <a href=\"https://www.circle.com/en/legal/usdc-terms\" target=\"_blank\">USDC User Agreement</a>, <a href=\"https://www.circle.com/en/legal/acceptable-use-policy\" target=\"_blank\">Applicable Use Policy</a> and <a href=\"https://www.circle.com/en/legal/privacy-policy\" target=\"_blank\">Privacy Policy</a>. I confirm I am the sole beneficial owner of the wallet and digital assets contained therein, and am acting solely on my own behalf.",
                "mobilePara1": {
                    "stringOne": "Circle Internet Financial, Inc. (“Circle”) is responsible for providing the exchange service from USD to USDC. I agree to Circle’s",
                    "stringTwo": ",",
                    "stringThree": ". I confirm I am the sole beneficial owner of the wallet and digital assets contained therein, and am acting solely on my own behalf."
                },
                "mgDisclaimerPara2": "MoneyGram Payment Systems, Inc. (“MoneyGram”) is responsible for providing the money transfer service from USD to USD (for USD Cash In) and from any other applicable currency to USD (for non-USD Cash In). MoneyGram may apply a currency exchange for any non-USD Cash In. MoneyGram makes money from currency exchange. The amounts shown are only estimates based on variable exchange rates. Final fees have not been applied."
            },
            "mgAgreementPara3": {
                "web": "I agree to MoneyGram’s <a href=\"https://www.moneygram.com/mgo/%s1/%s2/m/crypto-terms-and-conditions\" target=\"_blank\">Terms and Conditions</a>. By continuing with this transaction I consent to the collection, use, disclosure and transfer (including cross-border transfer) of my personal information as described in MoneyGram’s <a href=\"https://www.moneygram.com/intl/Documents/V2-Documents/MPSI-US-Privacy-Notice-EN-Sept-2020.pdf\" target=\"_blank\">Privacy Notice</a>.",
                "mobile": {
                    "stringOne": "I agree to MoneyGram’s",
                    "stringTwo": ". By continuing with this transaction I consent to the collection, use, disclosure and transfer (including cross-border transfer) of my personal information as described in MoneyGram’s",
                    "stringThree": "."
                }
            }
        },
        "cancel": {
            "header": "Request to Cancel Transfer",
            "referenceNumber": "Reference No.",
            "purchaseAmount": "Purchase Amount",
            "kind": "Kind",
            "cashOut": "Cash-Out",
            "selectReason": "SELECT REASON",
            "selectDetail": "SELECT DETAIL",
            "cancelTransfer": "Cancel Transfer",
            "cancelationSuccessful": "Cancelation Successful",
            "cancelationSuccessfulHelpText": "Your refund will be credited to your wallet shortly.",
            "reasonNotFound": "Reason not found!"
        },
        "error": {
            "isRequired": "is required.",
            "countryRequired": "Country is required.",
            "stateRequired": "State is required.",
            "amountRequired": "Amount is required",
            "invalidAmount": "Please enter a valid amount",
            "exceedsTransactionLimit": "The amount exceeds the transaction limit.",
            "somethingHasGoneWrong": "Something has gone wrong on our end. Please try again.",
            "processingError": "Sorry, we ran into an error while processing your transaction.",
            "notAvailableInCountry": "Sorry, this service is not available in",
            "amountExceededBalance": "Amount exceeded the balance in your wallet, please check the balance and amount requested",
            "unableToProcessInTime": "Unable to processing the request with in time, please retry",
            "unableToProcess": "Unable to processing the request, please retry",
            "receiveAmountLessThanMin": "Receive amount less than minimum amount for this destination.",
            "locationNotSupported": "This location does not support the transaction. Please select another location.",
            "maximumReceiveAmount": "Maximum Receive Amount in USD is 950",
            "missingFields": "One or more missing fields",
            "invalidIdInfo": "Sorry, the ID information you provided is invalid.",
            "refundNotAllowedTransactionInProgress": "Refund not allowed. Transaction is already in progress",
            "walletNotEligible": "Unfortunately, this wallet is not eligible for MoneyGram transactions at this time.",
            "unexpectedErrorContactMoneygram": "Unexpected Error. Please Contact Moneygram For Assistance.",
            "maximumWithdrawalAmount": "The withdrawal amount exceeds the transaction limit of 2500 USDC"
        },
        "serviceUnavailable": {
            "header": "It's not you, it’s us.",
            "accessDown": "MoneyGram Access is down.",
            "checkBackSoon": "Please check back soon."
        },
        "customerSupport": {
            "phoneLabel": "Stellar Support US:",
            "submitHelpRequest": "Submit a help request",
            "onlineHelpForm": "Online Help form",
            "emailLabel": "Email",
            "supportUrl": "https://www.moneygram.com/mgo/us/en/help/contact",
            "supportPhoneNumber": "800-513-5175",
            "emailAddress": "digitalsupport@moneygram.com"
        },
        "fraud": {
            "warning": "Warning!",
            "pleaseBeAware": "Please be aware cryptocurrency transactions <b>are not</b> reversible. Cryptocurrency trading can expose you to scams.",
            "fraudScenarios": "If there is a chance that you fit into any of the below scenarios or unsure about the purpose of your cash-in transaction, please do not proceed:",
            "fraudBulletOne": "Someone you met online has suggested or asked you to make this transaction.",
            "fraudBulletTwo": "Someone provided you with a link leading you to make this transaction.",
            "fraudBulletThree": "You have been told to do this transaction to purchase something, secure employment, or have been promised a guaranteed or unusually high return (Example: QSI Scam).",
            "beforeDeciding": "Before deciding to invest or trade cryptocurrencies you should carefully consider your investment objectives, level of experience, and risk appetite.",
            "agreeAndContinue": "Agree and continue"
        },
        "enumsObj": {
            "CANCEL_REASON_CODE": {
                "FR_FRAUD": "FR - Fraudulent Trans",
                "NL_NO_RCV_LOC": "NL - No Receive Location",
                "WU_WRONG_SERVICE": "WU - S/B Western Union",
                "TQ_NO_TQ": "TQ - Need to Add TQ/A",
                "IE_INCORRECT_AMT": "IE - Input Error",
                "MS_ES_NOT_USED": "MS-S/B MG # Transaction",
                "WA_WRONG_AGENT": "WA - Wrong Agent #",
                "WC_WRONG_CARRIER": "WC - Wrong Carrier",
                "UN_UNABLE_VERIFY": "UN - Unable To Verify",
                "30_UNWILLING_UNABLE_PROVIDE": "30: Unable To Provide Info"
            },
            "CARD_BRAND": {
                "V": "Visa",
                "M": "MasterCard",
                "A": "American Express",
                "D": "Discover"
            },
            "CNSMR_LANG": {
                "en-US": "English",
                "es-US": "Spanish",
                "fr-CA": "French (CA)",
                "pt-BR": "Portuguese",
                "en-GB": "English(UK)",
                "tl-PH": "Tagalog",
                "pl-PL": "Polish (Poland)"
            },
            "CNSMR_OPTIN": {
                "SMS": "Text",
                "BOTH": "Text & Email",
                "EMAIL": "Email",
                "NONE": "None"
            },
            "COMMIT_ABNDNED_RSNS": {
                "DOES_NT_KNOW_INFO": "Does not know information",
                "DOES_NT_KNOW_TP_INFO": "3rd Party details unknown",
                "REFUSE_INFO": "Declined to provide",
                "REFUSE_TP_INFO": "3rd Party details declined"
            },
            "DOCUMENT_TYPE": {
                "CUSTOMER_SEND_RECEIPT": "Send Receipt",
                "AGENT_SEND_RECEIPT": "Agent Send Receipt",
                "CUSTOMER_SEND_PREPAYMENT_DISCLOSURE": "Send Prepayment Disclosure",
                "CUSTOMER_SEND_CANCEL_RECEIPT": "Cancel Receipt",
                "AGENT_SEND_CANCEL_RECEIPT": "Agent Cancel Receipt",
                "CUSTOMER_SEND_AMEND_RECEIPT": "Amend Receipt",
                "AGENT_SEND_AMEND_RECEIPT": "Agent Amend Receipt",
                "SEND_PROOF_OF_FUNDS": "Send Proof of Funds",
                "SEND_PROOF_OF_ADDRESS": "Send Proof of Address",
                "CUSTOMER_RECEIVE_RECEIPT": "Receive Receipt",
                "AGENT_RECEIVE_RECEIPT": "Agent Receive Receipt",
                "RECEIVE_PROOF_OF_ADDRESS": "Receive Proof of Address",
                "CUSTOMER_BILLPAY_RECEIPT": "Bill Pay Receipt",
                "AGENT_BILLPAY_RECEIPT": "Agent Bill Pay Receipt",
                "CUSTOMER_BILLPAY_PREPAYMENT_DISCLOSURE": "Bill Pay Prepayment Disclosure",
                "ADDITIONAL_TRANSACTIONAL_DOCUMENT": "Additional Transaction Document"
            },
            "EP_REFUND_REAS_CODE": {
                "EP_PAYMENT_REJECTION": "2: Payment Rejection",
                "EP_RPPS_REJECT_RETURN": "5: RPPS Reject / Return",
                "EP_UNIDENTIFIED_PAYMENT": "6: Unidentified Payment",
                "EP_WRONG_RCVCODE_ACCT": "7: Wrong Receive Code",
                "19_FRAUD": "19: Fraudulent Transaction",
                "EP_WRONG_AMT_SENT": "50: Wrong Amt Sent - EP",
                "EP_PHOTOCOPY_REEMB": "58: Photocopy Refund",
                "EP_BILLER_NOT_IN_NETWORK": "60: Biller Not In Network",
                "EP_TRAN_FEE_REFUND": "63: EP Trans Fee Refund",
                "EP_CNSMR_GOOD_WILL": "64: EP Consumer Good Will",
                "MGO_EP_PAYMENT_DISPUTE": "70: MGO EP Payment Issue",
                "MGO_BILLER_RETURN_FUNDS": "71: MGO Biller Return Of Funds"
            },
            "GENDER": {
                "MALE": "Male",
                "FEMALE": "Female",
                "UNKNOWN": "Not Known / Not Given"
            },
            "NAME_SUFFIX": {
                "--": "--",
                "I": "I",
                "II": "II",
                "III": "III",
                "IV": "IV",
                "V": "V",
                "JR": "Jr.",
                "SR": "Sr."
            },
            "NAME_TITLE": {
                "SIR": "Sir",
                "DAME": "Dame",
                "LORD": "Lord",
                "LADY": "Lady",
                "PROF": "Professor",
                "DR": "Doctor",
                "MR": "Mister",
                "MISS": "Miss",
                "MRS": "Mrs",
                "MS": "Ms",
                "M": "Monsieur",
                "MLLE": "Mademoiselle",
                "MME": "Madame",
                "SIG": "Signor",
                "SIG.NA": "Signorina",
                "SIG.RA": "Signora",
                "SR": "Señor",
                "SRTA": "Señorita",
                "SRA": "Señora",
                "HERR": "Herr",
                "FRAU": "Frau",
                "PAN": "Pan",
                "PANI": "Pani"
            },
            "OCCUPATION": {
                "ADMIN": "Administrative",
                "AGRICULTURE": "Agriculture",
                "AUTOMOTIVE_SALES": "Automotive",
                "BANKING": "Financial Services",
                "CLERGY": "Religious",
                "COMPUTER": "Information Technology (IT)",
                "CUSTOMER_CARE": "Customer Care/Retail",
                "EDUCATION": "Education",
                "ENGINEER": "Engineer",
                "FACTORY": "Physical Worker",
                "HEALTH_SERVICES": "Healthcare",
                "PUBLIC_OFFICIAL": "Public Servant",
                "RESTAURANT": "Restaurant",
                "RETIRED": "Retiree",
                "STUDENT": "Student",
                "UNEMPLOYED": "Unemployed/Homemaker",
                "CONSULTING": "Consulting",
                "ENTERTAINMENT": "Entertainment",
                "EXECUTIVE": "Executive",
                "EXPLICIT_SERVICES": "Explicit Services",
                "HUMAN_RESOURCES": "Human Resources",
                "LEGAL": "Legal",
                "PERSONAL_SERVICES": "Personal Services",
                "SPORT": "Sport",
                "CLEAN_SERVICES": "Cleaning Services (Maid, Janitor, Carpet Cleaner, Hotel)",
                "CONSTRUCT_WORKER": "Construction / Repair (Residential, Industrial, Commercial)",
                "GENERAL_LABOR": "General Labor (Mason, Construction)",
                "HOMEMAKER": "Homemaker",
                "PROF_DRIVER": "Professional Driver (Taxi, Limo, Trucking, Delivery)",
                "GOV_EMPLOYEE": "Government Employee / Military / Police",
                "FARMER": "Farming",
                "FISHERMEN": "Fishing",
                "PROFESSOR": "Professor",
                "RETAIL": "Cashier",
                "STOCK_CLERK": "Stock Clerk",
                "NURSE": "Nurse",
                "DOCTOR": "Doctor",
                "PERSONAL_SUPPORT": "Personal Support Worker",
                "CHILD_CARE": "Childcare Services",
                "ENTREPRENEUR": "Entrepreneur"
            },
            "PAYMENT_TYPE": {
                "CA": "Cash",
                "CC": "Credit Card",
                "DC": "Debit Card",
                "PC": "Prepaid Card",
                "CHK": "Check",
                "EFT": "Electronic Funds Transfer",
                "WAL": "Digital Wallet",
                "UK": "Other Non-Cash"
            },
            "PAYOUT1_TYPE": {
                "A": "Agent",
                "C": "Consumer"
            },
            "PAYOUT2_TYPE": {
                "A": "Agent",
                "C": "Consumer",
                "N": "None"
            },
            "PERSONAL_ID1_CHOICE": {
                "ALN": "Alien ID",
                "DRV": "Drivers License",
                "GOV": "Government ID",
                "PAS": "Passport",
                "STA": "State ID",
                "NEW": "New ID",
                "PTI": "Provincial or Territorial Government Identification Cards",
                "CIS": "Certificate of Indian Status",
                "PRC": "Permanent Resident Card",
                "MCV": "Mexican Credential to Vote",
                "GDPI": "Guatemalan Personal Identification Document",
                "RPCD": "Refugee Protection Claimant Document"
            },
            "PERSONAL_ID1_TYPE": {
                "ALN": "Alien ID",
                "DRV": "Drivers License",
                "GOV": "Government ID",
                "PAS": "Passport",
                "STA": "State ID",
                "PTI": "Provincial or Territorial Government Identification Cards",
                "CIS": "Certificate of Indian Status",
                "PRC": "Permanent Resident Card",
                "MCV": "Mexican Credential to Vote",
                "GDPI": "Guatemalan Personal Identification Document"
            },
            "PERSONAL_ID2_CHOICE": {
                "ALN": "Alien ID",
                "INT": "International ID",
                "SSN": "Social Security Number",
                "TAX": "Tax ID",
                "NEW": "New ID",
                "PESEL": "PESEL"
            },
            "PERSONAL_ID2_TYPE": {
                "ALN": "Alien ID",
                "INT": "International ID",
                "SSN": "Social Security Number",
                "TAX": "Tax ID",
                "PESEL": "PESEL"
            },
            "POE_CHANNEL_TYPE": {
                "ATM": "ATM",
                "CALL_CENTER": "Call Center",
                "KIOSK": "Kiosk",
                "LOCATION": "Location (B&M)",
                "MOBILE": "Mobile",
                "SYSTEM": "System",
                "WEB": "Web",
                "TABLET": "Tablet"
            },
            "POE_TYPE": {
                "MGI_INTERNAL_INQUIRY": "MGI Internal Inquiry",
                "AGENTCONNECT": "AgentConnect",
                "AGENTWORKS": "AgentWorks",
                "DT4": "DT4",
                "AUTO_TRANSACTION": "Automated Transaction",
                "BPG": "Biller Partner Gateway",
                "ESCHEATED": "Escheated",
                "REGULATOR_REFUND": "Regulatory Refund",
                "DELTAWORKS": "DeltaWorks",
                "DT3": "DT3",
                "IVR": "Interactive Voice Response",
                "MGO": "MoneyGram Online",
                "PAYMENT_TRACKER": "Payment Tracker",
                "POWERTRANSACT": "PowerTransact",
                "SERVICEWORKS": "ServiceWorks",
                "STAGING_KIOSK": "Staging Kiosk",
                "MF_VOICE": "Voice / Mainframe",
                "IN_LANE_REDEM": "In Lane Redemption",
                "RPG": "Ripple Partner Gateway"
            },
            "PROOF_OF_FUNDS": {
                "ACT_OF_ATTORNEY": "Act of Attorney",
                "BANK_STATEMENT": "Bank account statement",
                "NATIONAL_LOTTERY": "Copy of Check",
                "PAYROLL_SLIP": "Payroll slip",
                "SALE_CERTIFICATE": "Sales certificate",
                "TAX_NOTICE": "Income Tax Notice"
            },
            "PRSONL_ID_ISUR_TYPE": {
                "AB": "Agency or Bureau",
                "CO": "Commissioners Office",
                "CON": "Consulate",
                "COR": "Corporation",
                "EMB": "Embassy"
            },
            "PURPSE_OF_TRNSCTION": {
                "BUSINESS_EXPENSE": "Business Expense",
                "DONATION": "Donation",
                "EDUCATION_TRAIN": "Education",
                "GIFT": "Gift",
                "INVEST_SAVING": "Investment",
                "LEGAL_OBLIGATION": "Legal Obligation",
                "LOAN": "Loan",
                "TRAVEL_EXPENSES": "Travel Expenses",
                "BILLS": "Bills",
                "FOOD": "Food",
                "MEDICAL": "Medical Expenses",
                "PURCHASE_GOODS": "Payment for Goods/Services",
                "PERSONAL_USE": "Personal Need/Expense",
                "SALARY": "Salary"
            },
            "PYMT_SVC_PRVDR": {
                "BPAY": "BPAY",
                "SOFORT": "Sofort",
                "INTERAC": "Interac",
                "PWMB": "PayWithMyBank"
            },
            "RCV_REVERSAL_RSNS": {
                "OUT_OF_CHECKS": "Agent is out of checks",
                "TECH_PROB": "Agent Technical Issue",
                "WANTS_CASH": "Cust wants cash not check",
                "ID_PROBLEM": "No ID/Wrong ID/Etc.",
                "WRONG_TX": "Wrong Transaction"
            },
            "RCV_RVSL_REFUND_RSNS": {
                "EP_PAYMENT_REJECTION": "2: Payment Rejection",
                "EP_RPPS_REJECT_RETURN": "5: RPPS Reject / Return",
                "EP_UNIDENTIFIED_PAYMENT": "6: Unidentified Payment",
                "EP_WRONG_RCVCODE_ACCT": "7: Wrong Receive Code",
                "19_FRAUD": "19: Fraudulent Transaction",
                "EP_WRONG_AMT_SENT": "50: Wrong Amt Sent - EP",
                "MT_TRAN_FEE_REF": "51: MT Transaction Fee Refund",
                "WRONG_PAYOUT": "52: Wrong Payout W/OFF-SET",
                "NOT_PAID": "53: Closed Not Paid",
                "MT_CONS_GOODWILL": "54: MT Consumer Goodwill",
                "CASH_FREE_REIMB": "55: Cashing Fee Reimbursement",
                "EP_PHOTOCOPY_REEMB": "58: Photocopy Refund",
                "STOPPED": "59: Stopped MO/Check Internal",
                "EP_BILLER_NOT_IN_NETWORK": "60: Biller Not In Network",
                "WRONG_PAYOUT_WOUT": "62: Wrong Payout W/O OFF_SET",
                "EP_TRAN_FEE_REFUND": "63: EP Trans Fee Refund",
                "EP_CNSMR_GOOD_WILL": "64: EP Consumer Good Will",
                "MGO_EP_PAYMENT_DISPUTE": "70: MGO EP Payment Issue",
                "MGO_BILLER_RETURN_FUNDS": "71: MGO Biller Return Of Funds",
                "OTHER": "99: (Other)"
            },
            "REFUND_REASON_CODE": {
                "1_NAME_AMEND": "1: Name Amend Refund",
                "3_WRONG_SRV_MX": "3: MX Wrong Service",
                "4_WRONG_SERVICE": "4: Wrong transfer service",
                "8_RRN_PROB": "8: RRN / DSS Acct Issue",
                "9_TECH_PROB": "9: Agent Technical Issue",
                "10_COMPETITOR": "10: Should be competitor",
                "11_NO_PICKUP": "11: Failed to pickup funds",
                "13_MS_NOT_USED": "13: Global Aggregation",
                "14_NO_RCV_LOC": "14: No receive location",
                "15_CHANGE_MIND": "15: Customer Changed Mind",
                "16_DUP_TRAN": "16: Duplicate Transaction",
                "17_FAIL_COLLECT": "17: Agent Failed to Collect",
                "18_STATE_CNTRY_REST": "18: ST/Country Restriction",
                "19_FRAUD": "19: Fraudulent Transaction",
                "20_PROB_AT_LOC": "20: Payout issue at rec",
                "22_NO_TQ": "22: Missing Test question",
                "23_INCORRECT_AMT": "23: Wrong Amount Sent",
                "24_COMPLIANCE": "24: PFC / Compliance",
                "25_CODE_45": "25: CODE 45 Override",
                "26_SB_EP": "26: Should Be EP",
                "27_WRONG_STATE": "27: Wrong state",
                "28_WRONG_CNTRY": "28: Wrong Country",
                "29_WRONG_CRNCY": "29: Wrong Currency",
                "30_UNWILLING_UNABLE_PROVIDE": "30: Unable To Provide Info",
                "OTHER": "99: (Other)",
                "WRONG_PAYOUT": "52: Wrong Payout W/OFF-SET",
                "NOT_PAID": "53: Closed Not Paid",
                "WRONG_PAYOUT_WOUT": "62: Wrong Payout W/O OFF_SET"
            },
            "RELATIONSHP_TO_SNDR": {
                "ACQUAINTANCE": "Acquaintance",
                "BUSINESS_PARTNER": "Business Partner",
                "CLIENT": "Client",
                "EMPLOY_EMPLOYER": "Employee",
                "FAMILY": "Family Member",
                "FRIEND": "Close Friend",
                "CONTRACTOR": "Contractor",
                "EMPLOYER": "Employer",
                "MYSELF": "Myself",
                "ONLINE_FRIEND": "Online Friend",
                "THIRD_PARTY": "Third Party",
                "VENDOR": "Vendor"
            },
            "RLTIONSHP_TO_RECIVR": {
                "ACQUAINTANCE": "Acquaintance",
                "BUSINESS_PARTNER": "Business Partner",
                "CLIENT": "Client",
                "EMPLOY_EMPLOYER": "Employee",
                "FAMILY": "Family Member",
                "FRIEND": "Close Friend",
                "CONTRACTOR": "Contractor",
                "EMPLOYER": "Employer",
                "MYSELF": "Myself",
                "ONLINE_FRIEND": "Online Friend",
                "THIRD_PARTY": "Third Party",
                "VENDOR": "Vendor"
            },
            "SEARCH_CRITERIA_NAME": {
                "NAME_PHONE_SEARCH": "Name and Phone",
                "NAME_DOB_SEARCH": "Name and Date of Birth",
                "REF_NUM_DOB_SEARCH": "Reference Number and Date of Birth",
                "NAME_AC_NUM_SEARCH": "Name and Account Number",
                "PLUS_NUM_SEARCH": "MoneyGram Plus Number"
            },
            "SEND_REVERSAL_RSNS": {
                "NO_RCV_LOC": "No Receive Location",
                "WRONG_SERVICE": "Wrong Transfer Service",
                "NO_TQ": "Missing Test Question",
                "INCORRECT_AMT": "Send/Receive/Amt Wrong",
                "MS_NOT_USED": "MG Plus was not entered",
                "TECH_PROB": "Agent Technical Issue",
                "CHANGE_MIND": "Customer Changed Mind",
                "DUP_TRAN": "Duplicate Transaction",
                "NO_PICKUP": "Failure to pickup funds",
                "PROB_AT_LOC": "Payout issue at rec",
                "STATE_CNTRY_REST": "ST/Country Restriction",
                "SB_EP": "Should Be EP",
                "WRONG_CNTRY": "Wrong Country",
                "WRONG_CRNCY": "Wrong Currency",
                "WRONG_STATE": "Wrong state"
            },
            "SOURCE_OF_FUNDS": {
                "LOAN": "Loan",
                "SAVINGS": "Savings",
                "SALE_OF_PROPERTY": "Sale of Property",
                "SALARY_EMPLOY": "Salary",
                "FAMILY_FUNDS": "Family Funds",
                "INHERITANCE": "Inheritance",
                "LOTTERY_GAMBLING": "Lottery/Gambling",
                "PENSION": "Pension",
                "SOCIAL_BENEFITS": "Social Benefits",
                "THIRD_PARTY": "Third Party"
            },
            "TARGET_AUDIENCE": {
                "AGENT_FACING": "Agent Facing",
                "CONSUMER_FACING": "Consumer Facing",
                "SERVICING": "Servicing"
            },
            "THRD_PRTY_TYPE_CODS": {
                "NONE": "None",
                "ORG": "Organization",
                "PERSON": "Person"
            },
            "TYPICAL_USE_OF_MGI": {
                "BUSINESS_RELATED": "Business-Related",
                "CHARITY_SUPPORT": "Charity Support",
                "FAMILY_FRIENDS_SUPPORT": "Family/Friend Support",
                "THIRD_PARTY": "Third Party"
            }
        },
        "refundCancelReasonsObj": {
            "NO_RCV_LOC": "No receive location",
            "WRONG_SERVICE": "Wrong transfer service",
            "NO_TQ": "Missing Test question",
            "INCORRECT_AMT": "Wrong Amount Sent",
            "MS_NOT_USED": "Global Aggregation",
            "TECH_PROB": "Agent Technical Issue",
            "CHANGE_MIND": "Customer Changed Mind",
            "DUP_TRAN": "Duplicate Transaction",
            "NO_PICKUP": "Failed to pickup funds",
            "PROB_AT_LOC": "Payout issue at rec",
            "STATE_CNTRY_REST": "ST/Country Restriction",
            "SB_EP": "Should Be EP",
            "WRONG_CNTRY": "Wrong Country",
            "WRONG_CRNCY": "Wrong Currency",
            "WRONG_STATE": "Wrong state"
        },
        "refundCancelReasons": {
            "reasonCodes": {
                "NL_NO_RCV_LOC": "I couldn't find a location",
                "INCORRECT_AMT": "I entered the wrong amount",
                "15_CHANGE_MIND": "I am no longer interested",
                "DUP_TRAN": "Duplicate Transaction",
                "WRONG_CRNCY": "I selected the wrong currency",
                "WRONG_CNTRY": "I selected the wrong country",
                "WRONG_STATE": "I selected the wrong state/province",
                "TECH_PROB": "I ran into issues at the location",
                "NO_PICKUP": "I didn't have time",
                "20_PROB_AT_LOC": "Agent didn't have enough funds",
                "INCOR_PRSNL_IDENT_INFO": "I entered the wrong identification details",
                "OTHER": "Other"
            },
            "subReasonCodes": {
                "LOC_CLOSED": "MoneyGram location was closed",
                "LOC_NOT_THERE": "MoneyGram location was not there",
                "LOC_OTH": "Other (Tell us more about what happened here)"
            },
            "reasonCodeLabels": {
                "LOC_OTH_LABEL": "Tell us more about what happened here",
                "TECH_PROB_LABEL": "Please describe the problem you had at the location:",
                "OTHER_LABEL": "Tell us more about your reason for cancelling"
            },
            "reasonCodeTextError": {
                "TEXT_BOX_MAX": "Maximum 500 characters",
                "CHAR_OVER_LIMIT": "characters over limit",
                "CHAR_REMAIN": "characters remaining"
            }
        },
        "country": {
            "AFG": {
                "iso2code": "AF",
                "name": "Afghanistan",
                "code": "AFG"
            },
            "ALB": {
                "iso2code": "AL",
                "name": "Albania",
                "code": "ALB"
            },
            "DZA": {
                "iso2code": "DZ",
                "name": "Algeria",
                "code": "DZA"
            },
            "ASM": {
                "iso2code": "AS",
                "name": "American Samoa",
                "code": "ASM"
            },
            "AND": {
                "iso2code": "AD",
                "name": "Andorra",
                "code": "AND"
            },
            "AGO": {
                "iso2code": "AO",
                "name": "Angola",
                "code": "AGO"
            },
            "AIA": {
                "iso2code": "AI",
                "name": "Anguilla",
                "code": "AIA"
            },
            "ATG": {
                "iso2code": "AG",
                "name": "Antigua And Barbuda",
                "code": "ATG"
            },
            "ARG": {
                "iso2code": "AR",
                "name": "Argentina",
                "code": "ARG"
            },
            "ARM": {
                "iso2code": "AM",
                "name": "Armenia",
                "code": "ARM"
            },
            "ABW": {
                "iso2code": "AW",
                "name": "Aruba",
                "code": "ABW"
            },
            "AUS": {
                "iso2code": "AU",
                "name": "Australia",
                "code": "AUS"
            },
            "AUT": {
                "iso2code": "AT",
                "name": "Austria",
                "code": "AUT"
            },
            "AZE": {
                "iso2code": "AZ",
                "name": "Azerbaijan",
                "code": "AZE"
            },
            "BHS": {
                "iso2code": "BS",
                "name": "Bahamas",
                "code": "BHS"
            },
            "BHR": {
                "iso2code": "BH",
                "name": "Bahrain",
                "code": "BHR"
            },
            "BGD": {
                "iso2code": "BD",
                "name": "Bangladesh",
                "code": "BGD"
            },
            "BRB": {
                "iso2code": "BB",
                "name": "Barbados",
                "code": "BRB"
            },
            "BLR": {
                "iso2code": "BY",
                "name": "Belarus",
                "code": "BLR"
            },
            "BEL": {
                "iso2code": "BE",
                "name": "Belgium",
                "code": "BEL"
            },
            "BLZ": {
                "iso2code": "BZ",
                "name": "Belize",
                "code": "BLZ"
            },
            "BEN": {
                "iso2code": "BJ",
                "name": "Benin",
                "code": "BEN"
            },
            "BMU": {
                "iso2code": "BM",
                "name": "Bermuda",
                "code": "BMU"
            },
            "BTN": {
                "iso2code": "BT",
                "name": "Bhutan",
                "code": "BTN"
            },
            "BOL": {
                "iso2code": "BO",
                "name": "Bolivia (Plurinational State of)",
                "code": "BOL"
            },
            "BES": {
                "iso2code": "BQ",
                "name": "Bonaire, Sint Eustatius and Saba",
                "code": "BES"
            },
            "BIH": {
                "iso2code": "BA",
                "name": "Bosnia And Herzegovina",
                "code": "BIH"
            },
            "BWA": {
                "iso2code": "BW",
                "name": "Botswana",
                "code": "BWA"
            },
            "BVT": {
                "iso2code": "BV",
                "name": "Bouvet Island",
                "code": "BVT"
            },
            "BRA": {
                "iso2code": "BR",
                "name": "Brazil",
                "code": "BRA"
            },
            "IOT": {
                "iso2code": "IO",
                "name": "British Indian Ocean Territory",
                "code": "IOT"
            },
            "BRN": {
                "iso2code": "BN",
                "name": "Brunei Darussalam",
                "code": "BRN"
            },
            "BGR": {
                "iso2code": "BG",
                "name": "Bulgaria",
                "code": "BGR"
            },
            "BFA": {
                "iso2code": "BF",
                "name": "Burkina Faso",
                "code": "BFA"
            },
            "BDI": {
                "iso2code": "BI",
                "name": "Burundi",
                "code": "BDI"
            },
            "KHM": {
                "iso2code": "KH",
                "name": "Cambodia",
                "code": "KHM"
            },
            "CMR": {
                "iso2code": "CM",
                "name": "Cameroon",
                "code": "CMR"
            },
            "CAN": {
                "iso2code": "CA",
                "name": "Canada",
                "code": "CAN",
                "states": {
                    "CA-AB": "Alberta",
                    "CA-BC": "British Columbia",
                    "CA-MB": "Manitoba",
                    "CA-NB": "New Brunswick",
                    "CA-NL": "Newfoundland And Labrador",
                    "CA-NT": "Northwest Territories",
                    "CA-NS": "Nova Scotia",
                    "CA-NU": "Nunavut",
                    "CA-ON": "Ontario",
                    "CA-PE": "Prince Edward Island",
                    "CA-QC": "Quebec",
                    "CA-SK": "Saskatchewan",
                    "CA-YT": "Yukon Territory"
                }
            },
            "CPV": {
                "iso2code": "CV",
                "name": "Cape Verde",
                "code": "CPV"
            },
            "CYM": {
                "iso2code": "KY",
                "name": "Cayman Islands",
                "code": "CYM"
            },
            "CAF": {
                "iso2code": "CF",
                "name": "Central African Republic",
                "code": "CAF"
            },
            "TCD": {
                "iso2code": "TD",
                "name": "Chad",
                "code": "TCD"
            },
            "CHL": {
                "iso2code": "CL",
                "name": "Chile",
                "code": "CHL"
            },
            "CHN": {
                "iso2code": "CN",
                "name": "China",
                "code": "CHN"
            },
            "CXR": {
                "iso2code": "CX",
                "name": "Christmas Island",
                "code": "CXR"
            },
            "CCK": {
                "iso2code": "CC",
                "name": "Cocos (Keeling) Islands",
                "code": "CCK"
            },
            "COL": {
                "iso2code": "CO",
                "name": "Colombia",
                "code": "COL"
            },
            "COM": {
                "iso2code": "KM",
                "name": "Comoros",
                "code": "COM"
            },
            "COD": {
                "iso2code": "CD",
                "name": "Congo, the Democratic Republic of",
                "code": "COD"
            },
            "COG": {
                "iso2code": "CG",
                "name": "Congo",
                "code": "COG"
            },
            "COK": {
                "iso2code": "CK",
                "name": "Cook Islands",
                "code": "COK"
            },
            "CRI": {
                "iso2code": "CR",
                "name": "Costa Rica",
                "code": "CRI"
            },
            "CIV": {
                "iso2code": "CI",
                "name": "Côte d'Ivoire",
                "code": "CIV"
            },
            "HRV": {
                "iso2code": "HR",
                "name": "Croatia",
                "code": "HRV"
            },
            "CUB": {
                "iso2code": "CU",
                "name": "Cuba",
                "code": "CUB"
            },
            "CUW": {
                "iso2code": "CW",
                "name": "Curaçao",
                "code": "CUW"
            },
            "CYP": {
                "iso2code": "CY",
                "name": "Cyprus",
                "code": "CYP"
            },
            "CZE": {
                "iso2code": "CZ",
                "name": "Czech Republic",
                "code": "CZE"
            },
            "DNK": {
                "iso2code": "DK",
                "name": "Denmark",
                "code": "DNK"
            },
            "DJI": {
                "iso2code": "DJ",
                "name": "Djibouti",
                "code": "DJI"
            },
            "DMA": {
                "iso2code": "DM",
                "name": "Dominica",
                "code": "DMA"
            },
            "DOM": {
                "iso2code": "DO",
                "name": "Dominican Republic",
                "code": "DOM"
            },
            "ECU": {
                "iso2code": "EC",
                "name": "Ecuador",
                "code": "ECU"
            },
            "EGY": {
                "iso2code": "EG",
                "name": "Egypt",
                "code": "EGY"
            },
            "SLV": {
                "iso2code": "SV",
                "name": "El Salvador",
                "code": "SLV"
            },
            "GNQ": {
                "iso2code": "GQ",
                "name": "Equatorial Guinea",
                "code": "GNQ"
            },
            "ERI": {
                "iso2code": "ER",
                "name": "Eritrea",
                "code": "ERI"
            },
            "EST": {
                "iso2code": "EE",
                "name": "Estonia",
                "code": "EST"
            },
            "SWZ": {
                "iso2code": "SZ",
                "name": "Swaziland",
                "code": "SWZ"
            },
            "ETH": {
                "iso2code": "ET",
                "name": "Ethiopia",
                "code": "ETH"
            },
            "FLK": {
                "iso2code": "FK",
                "name": "Falkland Islands (Malvinas)",
                "code": "FLK"
            },
            "FRO": {
                "iso2code": "FO",
                "name": "Faroe Islands",
                "code": "FRO"
            },
            "FJI": {
                "iso2code": "FJ",
                "name": "Fiji",
                "code": "FJI"
            },
            "FIN": {
                "iso2code": "FI",
                "name": "Finland",
                "code": "FIN"
            },
            "FRA": {
                "iso2code": "FR",
                "name": "France",
                "code": "FRA"
            },
            "GUF": {
                "iso2code": "GF",
                "name": "French Guiana",
                "code": "GUF"
            },
            "PYF": {
                "iso2code": "PF",
                "name": "French Polynesia",
                "code": "PYF"
            },
            "ATF": {
                "iso2code": "TF",
                "name": "French Southern Territories",
                "code": "ATF"
            },
            "GAB": {
                "iso2code": "GA",
                "name": "Gabon",
                "code": "GAB"
            },
            "GMB": {
                "iso2code": "GM",
                "name": "Gambia",
                "code": "GMB"
            },
            "GEO": {
                "iso2code": "GE",
                "name": "Georgia",
                "code": "GEO"
            },
            "DEU": {
                "iso2code": "DE",
                "name": "Germany",
                "code": "DEU"
            },
            "GHA": {
                "iso2code": "GH",
                "name": "Ghana",
                "code": "GHA"
            },
            "GIB": {
                "iso2code": "GI",
                "name": "Gibraltar",
                "code": "GIB"
            },
            "GRC": {
                "iso2code": "GR",
                "name": "Greece",
                "code": "GRC"
            },
            "GRL": {
                "iso2code": "GL",
                "name": "Greenland",
                "code": "GRL"
            },
            "GRD": {
                "iso2code": "GD",
                "name": "Grenada",
                "code": "GRD"
            },
            "GLP": {
                "iso2code": "GP",
                "name": "Guadeloupe",
                "code": "GLP"
            },
            "GUM": {
                "iso2code": "GU",
                "name": "Guam",
                "code": "GUM"
            },
            "GTM": {
                "iso2code": "GT",
                "name": "Guatemala",
                "code": "GTM"
            },
            "GGY": {
                "iso2code": "GG",
                "name": "Guernsey",
                "code": "GGY"
            },
            "GIN": {
                "iso2code": "GN",
                "name": "Guinea",
                "code": "GIN"
            },
            "GNB": {
                "iso2code": "GW",
                "name": "Guinea-Bissau",
                "code": "GNB"
            },
            "GUY": {
                "iso2code": "GY",
                "name": "Guyana",
                "code": "GUY"
            },
            "HTI": {
                "iso2code": "HT",
                "name": "Haiti",
                "code": "HTI"
            },
            "HMD": {
                "iso2code": "HM",
                "name": "Heard Island And Mcdonald Islands",
                "code": "HMD"
            },
            "VAT": {
                "iso2code": "VA",
                "name": "Holy See",
                "code": "VAT"
            },
            "HND": {
                "iso2code": "HN",
                "name": "Honduras",
                "code": "HND"
            },
            "HKG": {
                "iso2code": "HK",
                "name": "Hong Kong",
                "code": "HKG"
            },
            "HUN": {
                "iso2code": "HU",
                "name": "Hungary",
                "code": "HUN"
            },
            "ISL": {
                "iso2code": "IS",
                "name": "Iceland",
                "code": "ISL"
            },
            "IND": {
                "iso2code": "IN",
                "name": "India",
                "code": "IND"
            },
            "IDN": {
                "iso2code": "ID",
                "name": "Indonesia",
                "code": "IDN"
            },
            "IRN": {
                "iso2code": "IR",
                "name": "Iran (Islamic Republic Of)",
                "code": "IRN"
            },
            "IRQ": {
                "iso2code": "IQ",
                "name": "Iraq",
                "code": "IRQ"
            },
            "IRL": {
                "iso2code": "IE",
                "name": "Ireland",
                "code": "IRL"
            },
            "ISR": {
                "iso2code": "IL",
                "name": "Israel",
                "code": "ISR"
            },
            "ITA": {
                "iso2code": "IT",
                "name": "Italy",
                "code": "ITA"
            },
            "JAM": {
                "iso2code": "JM",
                "name": "Jamaica",
                "code": "JAM"
            },
            "JPN": {
                "iso2code": "JP",
                "name": "Japan",
                "code": "JPN"
            },
            "JEY": {
                "iso2code": "JE",
                "name": "Jersey",
                "code": "JEY"
            },
            "JOR": {
                "iso2code": "JO",
                "name": "Jordan",
                "code": "JOR"
            },
            "KAZ": {
                "iso2code": "KZ",
                "name": "Kazakhstan",
                "code": "KAZ"
            },
            "KEN": {
                "iso2code": "KE",
                "name": "Kenya",
                "code": "KEN"
            },
            "KIR": {
                "iso2code": "KI",
                "name": "Kiribati",
                "code": "KIR"
            },
            "KOR": {
                "iso2code": "KR",
                "name": "Korea, Republic of",
                "code": "KOR"
            },
            "PRK": {
                "iso2code": "KP",
                "name": "Korea (Democratic People's Republic Of)",
                "code": "PRK"
            },
            "XRK": {
                "iso2code": "XR",
                "name": "Kosovo",
                "code": "XRK"
            },
            "KWT": {
                "iso2code": "KW",
                "name": "Kuwait",
                "code": "KWT"
            },
            "KGZ": {
                "iso2code": "KG",
                "name": "Kyrgyzstan",
                "code": "KGZ"
            },
            "LAO": {
                "iso2code": "LA",
                "name": "Lao People's Democratic Republic",
                "code": "LAO"
            },
            "LVA": {
                "iso2code": "LV",
                "name": "Latvia",
                "code": "LVA"
            },
            "LBN": {
                "iso2code": "LB",
                "name": "Lebanon",
                "code": "LBN"
            },
            "LSO": {
                "iso2code": "LS",
                "name": "Lesotho",
                "code": "LSO"
            },
            "LBR": {
                "iso2code": "LR",
                "name": "Liberia",
                "code": "LBR"
            },
            "LBY": {
                "iso2code": "LY",
                "name": "Libya",
                "code": "LBY"
            },
            "LIE": {
                "iso2code": "LI",
                "name": "Liechtenstein",
                "code": "LIE"
            },
            "LTU": {
                "iso2code": "LT",
                "name": "Lithuania",
                "code": "LTU"
            },
            "LUX": {
                "iso2code": "LU",
                "name": "Luxembourg",
                "code": "LUX"
            },
            "MAC": {
                "iso2code": "MO",
                "name": "Macao",
                "code": "MAC"
            },
            "MKD": {
                "iso2code": "MK",
                "name": "Macedonia, the former Yugoslav Republic of",
                "code": "MKD"
            },
            "MDG": {
                "iso2code": "MG",
                "name": "Madagascar",
                "code": "MDG"
            },
            "MWI": {
                "iso2code": "MW",
                "name": "Malawi",
                "code": "MWI"
            },
            "MYS": {
                "iso2code": "MY",
                "name": "Malaysia",
                "code": "MYS"
            },
            "MDV": {
                "iso2code": "MV",
                "name": "Maldives",
                "code": "MDV"
            },
            "MLI": {
                "iso2code": "ML",
                "name": "Mali",
                "code": "MLI"
            },
            "MLT": {
                "iso2code": "MT",
                "name": "Malta",
                "code": "MLT"
            },
            "MHL": {
                "iso2code": "MH",
                "name": "Marshall Islands",
                "code": "MHL"
            },
            "MTQ": {
                "iso2code": "MQ",
                "name": "Martinique",
                "code": "MTQ"
            },
            "MRT": {
                "iso2code": "MR",
                "name": "Mauritania",
                "code": "MRT"
            },
            "MUS": {
                "iso2code": "MU",
                "name": "Mauritius",
                "code": "MUS"
            },
            "MYT": {
                "iso2code": "YT",
                "name": "Mayotte",
                "code": "MYT"
            },
            "MEX": {
                "iso2code": "MX",
                "name": "Mexico",
                "code": "MEX",
                "states": {
                    "MX-AGU": "Aguascalientes",
                    "MX-BCN": "Baja California",
                    "MX-BCS": "Baja California Sur",
                    "MX-CAM": "Campeche",
                    "MX-CHP": "Chiapas",
                    "MX-CHH": "Chihuahua",
                    "MX-DIF": "Ciudad De México",
                    "MX-COA": "Coahuila",
                    "MX-COL": "Colima",
                    "MX-DUR": "Durango",
                    "MX-GUA": "Guanajuato",
                    "MX-GRO": "Guerrero",
                    "MX-HID": "Hidalgo",
                    "MX-JAL": "Jalisco",
                    "MX-MEX": "México",
                    "MX-MIC": "Michoacán",
                    "MX-MOR": "Morelos",
                    "MX-NAY": "Nayarit",
                    "MX-NLE": "Nuevo León",
                    "MX-OAX": "Oaxaca",
                    "MX-PUE": "Puebla",
                    "MX-QUE": "Querétaro",
                    "MX-ROO": "Quintana Roo",
                    "MX-SLP": "San Luis Potosí",
                    "MX-SIN": "Sinaloa",
                    "MX-SON": "Sonora",
                    "MX-TAB": "Tabasco",
                    "MX-TAM": "Tamaulipas",
                    "MX-TLA": "Tlaxcala",
                    "MX-VER": "Veracruz",
                    "MX-YUC": "Yucatán",
                    "MX-ZAC": "Zacatecas"
                }
            },
            "FSM": {
                "iso2code": "FM",
                "name": "Micronesia (Federated States of)",
                "code": "FSM"
            },
            "MDA": {
                "iso2code": "MD",
                "name": "Moldova, Republic of",
                "code": "MDA"
            },
            "MCO": {
                "iso2code": "MC",
                "name": "Monaco",
                "code": "MCO"
            },
            "MNG": {
                "iso2code": "MN",
                "name": "Mongolia",
                "code": "MNG"
            },
            "MNE": {
                "iso2code": "ME",
                "name": "Montenegro",
                "code": "MNE"
            },
            "MSR": {
                "iso2code": "MS",
                "name": "Montserrat",
                "code": "MSR"
            },
            "MAR": {
                "iso2code": "MA",
                "name": "Morocco",
                "code": "MAR"
            },
            "MOZ": {
                "iso2code": "MZ",
                "name": "Mozambique",
                "code": "MOZ"
            },
            "MMR": {
                "iso2code": "MM",
                "name": "Myanmar",
                "code": "MMR"
            },
            "NAM": {
                "iso2code": "NA",
                "name": "Namibia",
                "code": "NAM"
            },
            "NRU": {
                "iso2code": "NR",
                "name": "Nauru",
                "code": "NRU"
            },
            "NPL": {
                "iso2code": "NP",
                "name": "Nepal",
                "code": "NPL"
            },
            "NLD": {
                "iso2code": "NL",
                "name": "Netherlands",
                "code": "NLD"
            },
            "ANT": {
                "iso2code": "AN",
                "name": "Netherlands Antilles",
                "code": "ANT"
            },
            "NCL": {
                "iso2code": "NC",
                "name": "New Caledonia",
                "code": "NCL"
            },
            "NZL": {
                "iso2code": "NZ",
                "name": "New Zealand",
                "code": "NZL"
            },
            "NIC": {
                "iso2code": "NI",
                "name": "Nicaragua",
                "code": "NIC"
            },
            "NER": {
                "iso2code": "NE",
                "name": "Niger",
                "code": "NER"
            },
            "NGA": {
                "iso2code": "NG",
                "name": "Nigeria",
                "code": "NGA"
            },
            "NIU": {
                "iso2code": "NU",
                "name": "Niue",
                "code": "NIU"
            },
            "NFK": {
                "iso2code": "NF",
                "name": "Norfolk Island",
                "code": "NFK"
            },
            "MNP": {
                "iso2code": "MP",
                "name": "Northern Mariana Islands",
                "code": "MNP"
            },
            "NOR": {
                "iso2code": "NO",
                "name": "Norway",
                "code": "NOR"
            },
            "OMN": {
                "iso2code": "OM",
                "name": "Oman",
                "code": "OMN"
            },
            "PAK": {
                "iso2code": "PK",
                "name": "Pakistan",
                "code": "PAK"
            },
            "PLW": {
                "iso2code": "PW",
                "name": "Palau",
                "code": "PLW"
            },
            "PSE": {
                "iso2code": "PS",
                "name": "Palestine, State of",
                "code": "PSE"
            },
            "PAN": {
                "iso2code": "PA",
                "name": "Panama",
                "code": "PAN"
            },
            "PNG": {
                "iso2code": "PG",
                "name": "Papua New Guinea",
                "code": "PNG"
            },
            "PRY": {
                "iso2code": "PY",
                "name": "Paraguay",
                "code": "PRY"
            },
            "PER": {
                "iso2code": "PE",
                "name": "Peru",
                "code": "PER"
            },
            "PHL": {
                "iso2code": "PH",
                "name": "Philippines",
                "code": "PHL"
            },
            "PCN": {
                "iso2code": "PN",
                "name": "Pitcairn",
                "code": "PCN"
            },
            "POL": {
                "iso2code": "PL",
                "name": "Poland",
                "code": "POL"
            },
            "PRT": {
                "iso2code": "PT",
                "name": "Portugal",
                "code": "PRT"
            },
            "PRI": {
                "iso2code": "PR",
                "name": "Puerto Rico",
                "code": "PRI"
            },
            "QAT": {
                "iso2code": "QA",
                "name": "Qatar",
                "code": "QAT"
            },
            "REU": {
                "iso2code": "RE",
                "name": "Réunion",
                "code": "REU"
            },
            "ROU": {
                "iso2code": "RO",
                "name": "Romania",
                "code": "ROU"
            },
            "RUS": {
                "iso2code": "RU",
                "name": "Russian Federation",
                "code": "RUS"
            },
            "RWA": {
                "iso2code": "RW",
                "name": "Rwanda",
                "code": "RWA"
            },
            "BLM": {
                "iso2code": "BL",
                "name": "Saint Barthélemy",
                "code": "BLM"
            },
            "SHN": {
                "iso2code": "SH",
                "name": "Saint Helena, Ascension And Tristan Da Cunha",
                "code": "SHN"
            },
            "KNA": {
                "iso2code": "KN",
                "name": "Saint Kitts And Nevis",
                "code": "KNA"
            },
            "LCA": {
                "iso2code": "LC",
                "name": "Saint Lucia",
                "code": "LCA"
            },
            "MAF": {
                "iso2code": "MF",
                "name": "Saint Martin (French Part)",
                "code": "MAF"
            },
            "SPM": {
                "iso2code": "PM",
                "name": "Saint Pierre And Miquelon",
                "code": "SPM"
            },
            "VCT": {
                "iso2code": "VC",
                "name": "Saint Vincent And The Grenadines",
                "code": "VCT"
            },
            "WSM": {
                "iso2code": "WS",
                "name": "Samoa",
                "code": "WSM"
            },
            "SMR": {
                "iso2code": "SM",
                "name": "San Marino",
                "code": "SMR"
            },
            "STP": {
                "iso2code": "ST",
                "name": "Sao Tome And Principe",
                "code": "STP"
            },
            "SAU": {
                "iso2code": "SA",
                "name": "Saudi Arabia",
                "code": "SAU"
            },
            "SEN": {
                "iso2code": "SN",
                "name": "Senegal",
                "code": "SEN"
            },
            "SRB": {
                "iso2code": "RS",
                "name": "Serbia",
                "code": "SRB"
            },
            "SCG": {
                "iso2code": "CS",
                "name": "Serbia And Montenegro",
                "code": "SCG"
            },
            "SYC": {
                "iso2code": "SC",
                "name": "Seychelles",
                "code": "SYC"
            },
            "SLE": {
                "iso2code": "SL",
                "name": "Sierra Leone",
                "code": "SLE"
            },
            "SGP": {
                "iso2code": "SG",
                "name": "Singapore",
                "code": "SGP"
            },
            "SXM": {
                "iso2code": "SX",
                "name": "Sint Maarten (Dutch part)",
                "code": "SXM"
            },
            "SVK": {
                "iso2code": "SK",
                "name": "Slovakia",
                "code": "SVK"
            },
            "SVN": {
                "iso2code": "SI",
                "name": "Slovenia",
                "code": "SVN"
            },
            "SLB": {
                "iso2code": "SB",
                "name": "Solomon Islands",
                "code": "SLB"
            },
            "SOM": {
                "iso2code": "SO",
                "name": "Somalia",
                "code": "SOM"
            },
            "ZAF": {
                "iso2code": "ZA",
                "name": "South Africa",
                "code": "ZAF"
            },
            "SGS": {
                "iso2code": "GS",
                "name": "South Georgia And The South Sandwich Islands",
                "code": "SGS"
            },
            "SSD": {
                "iso2code": "SS",
                "name": "South Sudan",
                "code": "SSD"
            },
            "ESP": {
                "iso2code": "ES",
                "name": "Spain",
                "code": "ESP"
            },
            "LKA": {
                "iso2code": "LK",
                "name": "Sri Lanka",
                "code": "LKA"
            },
            "SDN": {
                "iso2code": "SD",
                "name": "Sudan",
                "code": "SDN"
            },
            "SUR": {
                "iso2code": "SR",
                "name": "Suriname",
                "code": "SUR"
            },
            "SJM": {
                "iso2code": "SJ",
                "name": "Svalbard And Jan Mayen",
                "code": "SJM"
            },
            "SWE": {
                "iso2code": "SE",
                "name": "Sweden",
                "code": "SWE"
            },
            "CHE": {
                "iso2code": "CH",
                "name": "Switzerland",
                "code": "CHE"
            },
            "SYR": {
                "iso2code": "SY",
                "name": "Syrian Arab Republic",
                "code": "SYR"
            },
            "TWN": {
                "iso2code": "TW",
                "name": "Taiwan",
                "code": "TWN"
            },
            "TJK": {
                "iso2code": "TJ",
                "name": "Tajikistan",
                "code": "TJK"
            },
            "TZA": {
                "iso2code": "TZ",
                "name": "Tanzania, United Republic of",
                "code": "TZA"
            },
            "THA": {
                "iso2code": "TH",
                "name": "Thailand",
                "code": "THA"
            },
            "XQA": {
                "iso2code": "XQ",
                "name": "Tibet",
                "code": "XQA"
            },
            "TLS": {
                "iso2code": "TL",
                "name": "Timor-Leste",
                "code": "TLS"
            },
            "TGO": {
                "iso2code": "TG",
                "name": "Togo",
                "code": "TGO"
            },
            "TKL": {
                "iso2code": "TK",
                "name": "Tokelau",
                "code": "TKL"
            },
            "TON": {
                "iso2code": "TO",
                "name": "Tonga",
                "code": "TON"
            },
            "TTO": {
                "iso2code": "TT",
                "name": "Trinidad And Tobago",
                "code": "TTO"
            },
            "TUN": {
                "iso2code": "TN",
                "name": "Tunisia",
                "code": "TUN"
            },
            "TUR": {
                "iso2code": "TR",
                "name": "Turkey",
                "code": "TUR"
            },
            "TKM": {
                "iso2code": "TM",
                "name": "Turkmenistan",
                "code": "TKM"
            },
            "TCA": {
                "iso2code": "TC",
                "name": "Turks And Caicos Islands",
                "code": "TCA"
            },
            "TUV": {
                "iso2code": "TV",
                "name": "Tuvalu",
                "code": "TUV"
            },
            "UGA": {
                "iso2code": "UG",
                "name": "Uganda",
                "code": "UGA"
            },
            "UKR": {
                "iso2code": "UA",
                "name": "Ukraine",
                "code": "UKR"
            },
            "ARE": {
                "iso2code": "AE",
                "name": "United Arab Emirates",
                "code": "ARE"
            },
            "GBR": {
                "iso2code": "GB",
                "name": "United Kingdom Of Great Britain And Northern Ireland",
                "code": "GBR"
            },
            "USA": {
                "iso2code": "US",
                "name": "United States",
                "code": "USA",
                "states": {
                    "US-AL": "Alabama",
                    "US-AK": "Alaska",
                    "US-AZ": "Arizona",
                    "US-AR": "Arkansas",
                    "US-CA": "California",
                    "US-CO": "Colorado",
                    "US-CT": "Connecticut",
                    "US-DE": "Delaware",
                    "US-DC": "District Of Columbia",
                    "US-FL": "Florida",
                    "US-GA": "Georgia",
                    "US-HI": "Hawaii",
                    "US-ID": "Idaho",
                    "US-IL": "Illinois",
                    "US-IN": "Indiana",
                    "US-IA": "Iowa",
                    "US-KS": "Kansas",
                    "US-KY": "Kentucky",
                    "US-LA": "Louisiana",
                    "US-ME": "Maine",
                    "US-MD": "Maryland",
                    "US-MA": "Massachusetts",
                    "US-MI": "Michigan",
                    "US-MN": "Minnesota",
                    "US-MS": "Mississippi",
                    "US-MO": "Missouri",
                    "US-MT": "Montana",
                    "US-NE": "Nebraska",
                    "US-NV": "Nevada",
                    "US-NH": "New Hampshire",
                    "US-NJ": "New Jersey",
                    "US-NM": "New Mexico",
                    "US-NY": "New York",
                    "US-NC": "North Carolina",
                    "US-ND": "North Dakota",
                    "US-OH": "Ohio",
                    "US-OK": "Oklahoma",
                    "US-OR": "Oregon",
                    "US-PA": "Pennsylvania",
                    "US-RI": "Rhode Island",
                    "US-SC": "South Carolina",
                    "US-SD": "South Dakota",
                    "US-TN": "Tennessee",
                    "US-TX": "Texas",
                    "US-UT": "Utah",
                    "US-VT": "Vermont",
                    "US-VA": "Virginia",
                    "US-WA": "Washington",
                    "US-WV": "West Virginia",
                    "US-WI": "Wisconsin",
                    "US-WY": "Wyoming"
                }
            },
            "UMI": {
                "iso2code": "UM",
                "name": "United States of America Minor Outlying Islands",
                "code": "UMI"
            },
            "URY": {
                "iso2code": "UY",
                "name": "Uruguay",
                "code": "URY"
            },
            "UZB": {
                "iso2code": "UZ",
                "name": "Uzbekistan",
                "code": "UZB"
            },
            "VUT": {
                "iso2code": "VU",
                "name": "Vanuatu",
                "code": "VUT"
            },
            "VEN": {
                "iso2code": "VE",
                "name": "Venezuela (Bolivarian Republic of)",
                "code": "VEN"
            },
            "VNM": {
                "iso2code": "VN",
                "name": "Viet Nam",
                "code": "VNM"
            },
            "VGB": {
                "iso2code": "VG",
                "name": "Virgin Islands (British)",
                "code": "VGB"
            },
            "VIR": {
                "iso2code": "VI",
                "name": "Virgin Islands (U.S.)",
                "code": "VIR"
            },
            "WLF": {
                "iso2code": "WF",
                "name": "Wallis And Futuna",
                "code": "WLF"
            },
            "ESH": {
                "iso2code": "EH",
                "name": "Western Sahara",
                "code": "ESH"
            },
            "YEM": {
                "iso2code": "YE",
                "name": "Yemen",
                "code": "YEM"
            },
            "YUG": {
                "iso2code": "YU",
                "name": "Yugoslavia",
                "code": "YUG"
            },
            "ZMB": {
                "iso2code": "ZM",
                "name": "Zambia",
                "code": "ZMB"
            },
            "ZWE": {
                "iso2code": "ZW",
                "name": "Zimbabwe",
                "code": "ZWE"
            }
        },
        "sdfcard": {
            "common": {
                "continue": "Continue",
                "done": "Done",
                "yourPayAmount": "Your payment amount",
                "yourWithdrawAmount": "Your withdraw amount",
                "selectState": "Select state or province",
                "total": "Total",
                "myInfo": "My information",
                "legalName": "Legal name",
                "dateOfBirth": "Date of birth",
                "address": "Address",
                "phoneNumber": "Phone number",
                "myId": "My ID",
                "idType": "ID type",
                "idNumber": "ID number",
                "idDetails": "ID details",
                "countryOfIssue": "Country of issue",
                "stateLabel": "State or province of issue",
                "paymentLocation": "Payment Location",
                "selectLocation": "Select Location",
                "selectCountry": "Select country",
                "changeLocation": "Change location",
                "fees": "Fees",
                "taxes": "Taxes",
                "totalCost": "Total cost",
                "totalAmount": "Total amount",
                "totalPayAmount": "Total Pay Amount",
                "totalPickupAmount": "Total Pickup Amount",
                "yourExchangeAmount": "Your Exchange Amount",
                "yourWithdrawalAmount": "Your Withdrawal Amount",
                "partnerWalletFee": "%s1 Wallet Fee",
                "partnerWalletFeeFootnote": "Wallet fees will be added to the total cost in local currency",
                "notifcation": {
                    "one": "Be sure your information matches your ID"
                },
                "withdrawnFromwallet": "withdrawn from your wallet",
                "cancelTransaction": "Cancel transaction",
                "refundAmount": "Your refund amount",
                "authNumber": "Authorization No",
                "refundStepsOne": "Refunds to a credit or debit card typically take up to 10 business days",
                "refundStepsTwo": "While funds have been withdrawn, your bank may not show a charge immediately",
                "addedTowallet": "was added to your wallet",
                "youPaid": "You paid"
            },
            "landingPage": {
                "cashInHeadr": "Start cash-in with MoneyGram",
                "cashOutHeadr": "Start cash-out with MoneyGram",
                "cashInCountry": "Cash-in country",
                "cashOutCountry": "Cash-out country",
                "stateOrProvince": "State or province",
                "countrySelected": "Country selected",
                "searchForCountryPlaceholder": "Search for country",
                "searchForStateOrProvincePlaceholder": "Search for state or province",
                "allCountries": "All countries",
                "allStatesOrProvinces": "All states or provinces",
                "stateOrProvinceSelected": "State or province selected",
                "selectCurrency": "Select currency",
                "lookupLocation": "Lookup location",
                "multiCurrency": "has multiple currencies you can send",
                "disclaimer": {
                    "one": "1 The exchange currency amount will be converted to your local currency by the agent at the time of payment",
                    "two": "Fees are added to the total cost in local currency",
                    "three": "At the time of payment, the exchange currency rate may differ, affecting your total pay amount."
                },
                "payment": {
                    "payMethod": "Payment method",
                    "receiveMethod": "Receive method",
                    "cashPickUp": "Cash pickup",
                    "location": "Location",
                    "cashLocation": "Cash at location",
                    "cashInlocationFeesInfo": "Fees vary by location. Once you select a location, fees will appear for your estimation.",
                    "cashOutlocationFeesInfo": "Please note that you can go to any location from your search results for your cash pickup. Fees vary by location."
                }
            },
            "locationMaps": {
                "searchCityZipCode": "Search By City or Postal Code",
                "findLocationNearby": "Find a convenient location near you",
                "searchArea": "Search this area",
                "viewDetails": "View Details",
                "locationServices": "Services",
                "popular": "Popular",
                "nearby": "Nearby",
                "openNow": "Open Now",
                "notification": {
                    "infoVariable": "Specific hours of operation may vary. Please contact the location for more information.",
                    "searchNoResult": "We’re sorry, but we can’t locate any location with your search. Please try it again.",
                    "locationUnavailable": "No MoneyGram location is currently available for USDC services near you.",
                    "tryAgainFuture": "Please try again in the near future."
                },
                "storeDetails": {
                    "storeDetails": "Store details",
                    "store": "Store",
                    "services": "Services",
                    "beforeYouGo": "Before you go...",
                    "cashOnly": "You can only use cash for cash-related services at this location.",
                    "specificLocationHours": "Specific hours of operation may vary. Please contact the location for more information.",
                    "showStoreHours": "Show store hours",
                    "hideStoreHours": "Hide store hours",
                    "hours": "Hours"
                }
            },
            "moreInfoPage": {
                "littleInfo": "We need a little bit more information about you",
                "photoId": "This will assist our store agent in verifying your identity when you present your photo ID",
                "storeInfo": "We kindly ask the following detail to ensure a seamless experience at your store selected"
            },
            "basicInfoPage": {
                "header": "Basic Information"
            },
            "addressPage": {
                "header": "Address"
            },
            "reviewPage": {
                "reviewHeader": "Review information",
                "paymentLocation": "Payment location",
                "paymentInformation": "Payment information",
                "withdraw": {
                    "yourWithdrawalAmount": "Your withdrawal amount"
                },
                "deposit": {
                    "yourConvertingMethod": "Your converting method"
                }
            },
            "confirmationPage": {
                "cashInStatusHeader": "All set! Head to your payment location",
                "cashOutStatusHeader": "All set! Head to your pickup location",
                "payAtStore": "Pay at store",
                "pickAmount": "Your pickup amount",
                "amountAdding": "You are adding %s USDC to your wallet",
                "amountWithdraw": "You are withdrawing %s USDC from your wallet",
                "receiver": "Receiver",
                "howToPay": "How to pay your cash at location",
                "accountNumber": "Account number",
                "walletBalance": "Your wallet balance will be updated within a few minutes after payment",
                "nextStepsHeading": "Next steps are easy",
                "branchBanAccountRequired": "Please note that some banks require a branch bank account for your pickup.",
                "nextSteps": {
                    "idType": {
                        "ALN": "Alien ID",
                        "ALN_PREC": "Alien ID/Precaria",
                        "DRV": "Drivers License",
                        "GOV": "Government ID",
                        "PAS": "Passport",
                        "STA": "State ID"
                    },
                    "paraOne": "Within 24 hours, head to your payment location",
                    "paraTwo": "Have your %s selected and Account # above ready",
                    "tellTheStoreEmployee": "Tell the store employee",
                    "fundsIn": {
                        "common": {
                            "yourNameAsReceiver": "Your name as receiver",
                            "serviceOption": "The service option for employee to select is 'USDC wallet'"
                        },
                        "paraThree": {
                            "implicitTransUSCAN": {
                                "purpose": "I am here to send money to Texas, United States"
                            },
                            "implicitNoneUSCAN": {
                                "purpose": "I am here to send money to The United States"
                            },
                            "explicit": {
                                "paraTwo": "Have your %s selected",
                                "purpose": "Tell the store employee, \"I am here to complete my MoneyGram transaction\""
                            }
                        }
                    },
                    "fundsOut": {
                        "paraOne": "Within 60 days, head to any store from your search result",
                        "receiveCash": "I am here to receive cash from a MoneyGram transaction"
                    },
                    "onHold": {
                        "para1": "For your safety and security, we've placed your USDC wallet transaction on hold.",
                        "para2": "To complete your cash-in transaction, please contact our customer support team at 1-800-513-5175. For faster support, have your reference number ready."
                    },
                    "senderRejected": {
                        "para1": "We were unable to process your transaction.",
                        "para2CashIn": "Please return to your selected location in order to receive a refund.",
                        "para2CashOut": "Your refund will be automatically sent to your account."
                    }
                }
            }
        }
    }
}

export const sdfMockLabels = JSON.parse(JSON.stringify(sdfLabelsJSON))